import { useCallback } from "react";
import { Project, User, UserRole } from "data/api";

type ProjectUsers = (project: Project) => User[];

export const useProjectUsers = (): ProjectUsers => {
  return useCallback((project: Project) => {
    const projectManagers = (project.projectManagers || []).map((user) => ({
      ...user,
      projectRoles: [{ projectId: project.id, role: UserRole.ProjectManager }],
    }));
    const techs = (project.techs || []).map((tech) => ({
      ...tech,
      projectRoles: [{ projectId: project.id, role: UserRole.Tech }],
    }));
    const clients = (project.clients || []).map((client) => ({
      ...client,
      projectRoles: [{ projectId: project.id, role: UserRole.Client }],
    }));

    return [...projectManagers, ...techs, ...clients];
  }, []);
};

export const useActiveProjectUsers = (): ProjectUsers => {
  const getUsers = useProjectUsers();
  return useCallback(
    (project: Project) => {
      return getUsers(project).filter((user) => user.isActive);
    },
    [getUsers]
  );
};

export const useArchivedProjectUsers = (): ProjectUsers => {
  const getUsers = useProjectUsers();
  return useCallback(
    (project: Project) => {
      return getUsers(project).filter((user) => !user.isActive);
    },
    [getUsers]
  );
};
